<template>
  <div class="page engineering">
    <v-container class="page-content mt-8 mb-8 px-4 ">
      <Card class="mb-6">
        <SearchFilter></SearchFilter>
      </Card>
      <Card head title="招标中" :more="false">
        <Tabs :tab="this.tab" headCenterTitle="公司" headRightTitle="截止时间" :list="engineeringItems"></Tabs>
      </Card>
    </v-container>
    <CFooter></CFooter>
  </div>
</template>

<script>
import CFooter from '@/components/Common/Footer'
import { Card, Tabs } from '@/components/UI'
import SearchFilter from '@/components/Logistics/SearchFilter'
import { EngineeringTab } from '@/mixins/engineering'
export default {
  name: 'Engineering',
  mixins: [EngineeringTab],
  components: {
    CFooter,
    Card,
    SearchFilter,
    Tabs
  },
  data: () => {
    return {
      tab: 0,
      items: [{
        id: 0,
        title: '物资招标',
        status: 6
      }, {
        id: 1,
        title: '工程招标',
        status: 7
      }, {
        id: 2,
        title: '服务招标',
        status: 8
      }, {
        id: 3,
        title: '其他',
        status: 9
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
.engineering {
  .tabs {
    .tab {
      font-size: 16px;
      &.active {
        span {
          position: relative;
          &::after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            bottom: -2px;
            width: 100%;
            height: 2px;
            background-color: $main-color;
          }
        }
      }
      &:not(:last-child){
        &::after {
          content: '';
          position: absolute;
          right: -0.5px;
          width: 1px;
          height: 18px;
          background-color: rgba(0, 0, 0, 0.54);
        }
      }
    }
  }
}
</style>
